import { WidgetInitializer } from "../functions/widget-initializer";
import { ConfigUtils } from "../functions/config-utils";
import { Constants } from "../functions/constants";

var widgetInitializer = new WidgetInitializer(Constants.COMPONENTS.MY_DEALER_LOGIN);
GlobalApp.registerInitializationHandler(Constants.COMPONENTS.MY_DEALER_LOGIN, function () {
    widgetInitializer.initialize(initMyDealerLoginFormApp);
});

const CDK_LIBRARY_NAME = "QS36F";
var loginUrl;
var redirectUrl;
var loginForm;

function initMyDealerLoginFormApp(element) {
    var config = ConfigUtils.getConfigFor(element);
    loginUrl = config.myDealerSettings.MyDealerLoginRequestUrl;
    loginForm = config.myDealerSettings.MyDealerLoginPageUrl;

    console.info(config);

    if (config.selectedRedirectMode == config.ACH_REDIRECT_MODE)
        redirectUrl = config.myDealerSettings.MyDealerAchUrl;
    else
        redirectUrl = config.myDealerSettings.MyDealerDashboardUrl;

    var vueApp = new Vue({
        el: '#' + element.id,
        data: {
            customerDetails: {},
            shown: false,
            loading: false
        },
        methods: {
            openMyDealer: function () {
                if (!this.loading) {
                    this.loading = true;

                    if (!this.customerDetails.Error) {
                        cdkLogin(this.customerDetails.MydUserName, this.customerDetails.MydPassword, loginUrl, CDK_LIBRARY_NAME)
                    }
                    else {
                        window.location.href = loginForm;
                    }
                }
            }
        },
        async created() {
            this.customerDetails = await GlobalApp.CustomerService.getMyDealerInfo()

            if (this.customerDetails?.MydUserName) {
                this.shown = true
            }
        }
    })

    return vueApp.$el;
}

function cdkLogin(un, pw, pfwLink, pfwLibrary) {
    var xhr = new XMLHttpRequest();
    xhr.open("POST", pfwLink, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.withCredentials = true;
    xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
            var status = xhr.status;
            if (status === 0 || (status >= 200 && status < 400)) {
                window.location.href = redirectUrl;
            } else {
                window.location.href = loginForm;
            }
        }
    };
    xhr.send(JSON.stringify({ username: un, password: pw, system: "MD", library: pfwLibrary }));
}